import Moment from './_Moment';

export default class EditForm_PopIn extends Moment {
  constructor(props, context) {
    super(props, context, 'pop-in');
  }
}
